module.exports = __webpack_public_path__ + "static/img/jinan4.330ace87.jpg";